import React, { FunctionComponent } from 'react';
import { NeedHelpContactSupport as SharedNeedHelpContactSupport } from '@companion-professional/components';
import { CONTACT_EMAIL, CONTACT_PHONE } from '../../lib/config';

interface NeedHelpContactSupportProps {
  className?: string;
}

// NeedHelpContactSupport displays a message with links to contact (text or email) support for help.  It's a thin
// wrapper around the shared NeedHelpContactSupport that fills in the checkup app's support email and phone number.
export const NeedHelpContactSupport: FunctionComponent<NeedHelpContactSupportProps> = ({ className }) => (
  <SharedNeedHelpContactSupport className={className} contactEmail={CONTACT_EMAIL} contactPhone={CONTACT_PHONE} />
);
